import axios from "axios";

const HOST =
  process.env.API_IP + ":" + process.env.API_PORT + "/enedapi/client";
// const HOST = "https://teste.areareservada.ened-portugal.pt/enedapi/client";
const instance = axios.create({
  baseURL: HOST,
});

export { instance, HOST };



// WEBPACK FOOTER //
// ./src/store/axios.js